import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Title, Content, Wrapper } from './Modal.styles'
import { FontIcon } from 'components/lib/icons'
import { colors } from 'config/ui'
import ModalBase, { modalPropTypes } from './ModalBase'
import { ButtonIcon } from '@arvoreeducacao/bonsai-ds'

class Modal extends Component {
  static propTypes = {
    ...modalPropTypes,
    title: PropTypes.string,
    canCloseByXBtn: PropTypes.bool,
    // fullscreen is only for mobile (mobile first)
    fullScreen: PropTypes.bool,
    type: PropTypes.oneOf(['no-header', 'default']),
    noPadding: PropTypes.bool
  }

  static defaultProps = {
    title: '',
    canCloseByXBtn: true,
    fullScreen: false,
    type: 'default',
    noPadding: false
  }

  render() {
    const { title, children, canCloseByXBtn, type, noPadding, ...props } =
      this.props

    const headerEnabled = type !== 'no-header'

    return (
      <ModalBase {...props}>
        <Wrapper noPadding={noPadding}>
          {headerEnabled && (
            <Title>
              <strong>{title}</strong>
              {canCloseByXBtn && (
                <FontIcon
                  iconName={'clear'}
                  size={'24'}
                  color={colors.gray7}
                  onClick={props.onClose}
                  style={{ cursor: 'pointer' }}
                />
              )}
            </Title>
          )}
          {!headerEnabled && canCloseByXBtn && (
            <ButtonIcon
              className="close-button"
              iconName="cancel"
              aria-label="Fechar"
              onClick={props.onClose}
              theme={{ type: 'secondary', size: 'medium' }}
              colorDesktop={colors.black4}
              style={{
                top: `${noPadding ? '37' : '13'}px`,
                right: `${noPadding ? '37' : '10'}px`,
                zIndex: 1,
                position: 'absolute',
                cursor: 'pointer'
              }}
            />
          )}
          <Content>{children}</Content>
        </Wrapper>
      </ModalBase>
    )
  }
}

export default Modal
